/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UsersRestore} from '../models/UsersRestore';
import type {UsersRestoreResponse} from '../models/UsersRestoreResponse';

export interface GetRestoreUsersResult$Request {
    id: string;
}

export interface GetRestoreUsersResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getRestoreUsersResultRequest = createAction<PayloadData<void, GetRestoreUsersResult$Request>>('BULK_USERS_RESTORE__GET_RESTORE_USERS_RESULT__REQUEST');
export const getRestoreUsersResultSuccess = createAction<PayloadData<UsersRestoreResponse, GetRestoreUsersResult$Request>>('BULK_USERS_RESTORE__GET_RESTORE_USERS_RESULT__SUCCESS');
export const getRestoreUsersResultFailure = createAction<PayloadData<Error, GetRestoreUsersResult$Request, true>>('BULK_USERS_RESTORE__GET_RESTORE_USERS_RESULT__FAILURE');

export const getRestoreUsersResultActions = [
    getRestoreUsersResultRequest,
    getRestoreUsersResultSuccess,
    getRestoreUsersResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getRestoreUsersResult = (meta: GetRestoreUsersResult$Request, config?: GetRestoreUsersResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getRestoreUsersResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/conferences/restore-users`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUsersRestoreProgress$Request {
    id: string;
}

export interface GetUsersRestoreProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsersRestoreProgressRequest = createAction<PayloadData<void, GetUsersRestoreProgress$Request>>('BULK_USERS_RESTORE__GET_USERS_RESTORE_PROGRESS__REQUEST');
export const getUsersRestoreProgressSuccess = createAction<PayloadData<BulkProgress, GetUsersRestoreProgress$Request>>('BULK_USERS_RESTORE__GET_USERS_RESTORE_PROGRESS__SUCCESS');
export const getUsersRestoreProgressFailure = createAction<PayloadData<Error, GetUsersRestoreProgress$Request, true>>('BULK_USERS_RESTORE__GET_USERS_RESTORE_PROGRESS__FAILURE');

export const getUsersRestoreProgressActions = [
    getUsersRestoreProgressRequest,
    getUsersRestoreProgressSuccess,
    getUsersRestoreProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsersRestoreProgress = (meta: GetUsersRestoreProgress$Request, config?: GetUsersRestoreProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getUsersRestoreProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/conferences/restore-users/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RestoreUsers$Request {
    usersRestore: UsersRestore;
    reason?: string;
}

export interface RestoreUsers$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const restoreUsersRequest = createAction<PayloadData<void, RestoreUsers$Request>>('BULK_USERS_RESTORE__RESTORE_USERS__REQUEST');
export const restoreUsersSuccess = createAction<PayloadData<string, RestoreUsers$Request>>('BULK_USERS_RESTORE__RESTORE_USERS__SUCCESS');
export const restoreUsersFailure = createAction<PayloadData<Error, RestoreUsers$Request, true>>('BULK_USERS_RESTORE__RESTORE_USERS__FAILURE');

export const restoreUsersActions = [
    restoreUsersRequest,
    restoreUsersSuccess,
    restoreUsersFailure
] as const;

/**
 * @param {UsersRestore} meta.usersRestore
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const restoreUsers = (meta: RestoreUsers$Request, config?: RestoreUsers$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: restoreUsersActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/conferences/restore-users`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.usersRestore,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopUsersRestore$Request {
    id: string;
}

export interface StopUsersRestore$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopUsersRestoreRequest = createAction<PayloadData<void, StopUsersRestore$Request>>('BULK_USERS_RESTORE__STOP_USERS_RESTORE__REQUEST');
export const stopUsersRestoreSuccess = createAction<PayloadData<void, StopUsersRestore$Request>>('BULK_USERS_RESTORE__STOP_USERS_RESTORE__SUCCESS');
export const stopUsersRestoreFailure = createAction<PayloadData<Error, StopUsersRestore$Request, true>>('BULK_USERS_RESTORE__STOP_USERS_RESTORE__FAILURE');

export const stopUsersRestoreActions = [
    stopUsersRestoreRequest,
    stopUsersRestoreSuccess,
    stopUsersRestoreFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopUsersRestore = (meta: StopUsersRestore$Request, config?: StopUsersRestore$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopUsersRestoreActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/conferences/restore-users`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

